import { lazy } from 'react'

export const Home = lazy(() => import('../pages/AppHome/index.ts'))
export const AppAuditManagement = lazy(
  () => import('../pages/AppAuditManagement')
)
export const AppAuditManagementList = lazy(
  () => import('../pages/AppAuditManagementList')
)
export const AppAuditManagementExport = lazy(
  () => import('../pages/AppAuditManagementExport')
)
export const AppAuditManagementDetail = lazy(
  () => import('../pages/AppAuditManagementDetail')
)
export const AppFormManagement = lazy(
  () => import('../pages/AppFormManagement')
)
export const AppNewFieldModelManagement = lazy(
  () => import('../pages/AppFieldModelList')
)
export const AppFieldModelManagement = lazy(
  () => import('../pages/AppFieldModelManagement')
)
export const AppFieldModelManagementEdit = lazy(
  () => import('../pages/AppFieldModelManagementEdit')
)
export const AppFieldModelManagementCreate = lazy(
  () => import('../pages/AppFieldModelManagementCreate')
)
export const AppFieldModelManagementImport = lazy(
  () => import('../pages/AppFieldModelManagementImport')
)
export const AppPollUpdate = lazy(() => import('../pages/AppPollUpdate'))
export const AppCategoryPollList = lazy(
  () => import('../pages/AppCategoryPollList')
)
export const AppSettings = lazy(() => import('../pages/AppSettings'))
export const AppSettingsOthers = lazy(
  () => import('../pages/AppSettingsOthers')
)
export const AppSettingsMap = lazy(() => import('../pages/AppSettingsMap'))
export const AppPollDelete = lazy(() => import('../pages/AppPollDelete'))
export const AppCategoryPollNew = lazy(
  () => import('../pages/AppCategoryPollNew')
)
export const AppCategoryPollUpdate = lazy(
  () => import('../pages/AppCategoryPollUpdate')
)
export const AppCategoryPollDelete = lazy(
  () => import('../pages/AppCategoryPollDelete')
)
export const AppPollNew = lazy(() => import('../pages/AppPollNew'))
export const AppPollImport = lazy(() => import('../pages/AppPollImport'))
export const AppProjectManagement = lazy(
  () => import('../pages/AppProjectManagement')
)
export const AppProjectNew = lazy(() => import('../pages/AppProjectNew'))
export const AppProjectUpdate = lazy(() => import('../pages/AppProjectUpdate'))
export const AppProjectDelete = lazy(() => import('../pages/AppProjectDelete'))
export const AppAuditManagementAnswerUpdate = lazy(
  () => import('../pages/AppAuditManagementAnswerUpdate')
)
export const AppAuditManagementEntries = lazy(
  () => import('../pages/AppAuditManagementEntries')
)
export const AppReportTemplateManagement = lazy(
  () =>
    import('../pages/AppReportTemplateManagement/AppReportTemplateManagement')
)
export const AppReportNewFunctionality = lazy(
  () => import('../pages/AppReportNewFunctionality')
)
export const AppBreadcrumbDashboardManagement = lazy(
  () => import('../pages/AppBreadcrumbDashboardManagement')
)
export const AppInboxManagementList = lazy(
  () => import('../pages/AppInboxManagementList')
)
export const AppLayoutDashboardManagement = lazy(
  () => import('../pages/AppLayoutDashboardManagement')
)
export const AppLayoutDashboardUpdate = lazy(
  () => import('../pages/AppLayoutDashboardUpdate')
)
export const AppLayoutDashboardNew = lazy(
  () => import('../pages/AppLayoutDashboardNew')
)
export const AppLayoutDashboardDelete = lazy(
  () => import('../pages/AppLayoutDashboardDelete')
)
export const AppLayoutDashboardWidget = lazy(
  () => import('../pages/AppLayoutDashboardWidget')
)
export const AppLayoutDashboardWidgetNew = lazy(
  () => import('../pages/AppLayoutDashboardWidgetNew')
)
export const AppLayoutDashboardWidgetUpdate = lazy(
  () => import('../pages/AppLayoutDashboardWidgetUpdate')
)
export const AppLayoutDashboardWidgetDelete = lazy(
  () => import('../pages/AppLayoutDashboardWidgetDelete')
)
export const AppBreadcrumbDashboardNew = lazy(
  () => import('../pages/AppBreadcrumbDashboardNew')
)
export const AppBreadcrumbDashboardUpdate = lazy(
  () => import('../pages/AppBreadcrumbDashboardUpdate')
)
export const AppBreadcrumbDashboardDelete = lazy(
  () => import('../pages/AppBreadcrumbDashboardDelete')
)
export const AppUserManagement = lazy(
  () => import('../pages/AppUserManagement')
)
export const AppUserManagementNew = lazy(
  () => import('../pages/AppUserManagementNew')
)
export const AppUserManagementUpdate = lazy(
  () => import('../pages/AppUserManagementUpdate')
)
export const AppUserManagementChangePassword = lazy(
  () => import('../pages/AppUserManagementChangePassword')
)
export const AppUserManagementDelete = lazy(
  () => import('../pages/AppUserManagementDelete')
)
export const AppUserManagementActivity = lazy(
  () => import('../pages/AppUserManagementActivity')
)
export const AppUserManagementProfiles = lazy(
  () => import('../pages/AppUserManagementProfiles')
)
export const AppUserManagementProfilesNew = lazy(
  () => import('../pages/AppUserManagementProfilesNew')
)
export const AppUserManagementProfilesUpdate = lazy(
  () => import('../pages/AppUserManagementProfilesUpdate')
)
export const AppUserManagementProfilesDelete = lazy(
  () => import('../pages/AppUserManagementProfilesDelete')
)
export const AppUserManagementCompany = lazy(
  () => import('../pages/AppUserManagementCompany')
)
export const AppUserManagementCompanyNew = lazy(
  () => import('../pages/AppUserManagementCompanyNew')
)
export const AppUserManagementCompanyUpdate = lazy(
  () => import('../pages/AppUserManagementCompanyUpdate')
)
export const AppUserManagementCompanyDelete = lazy(
  () => import('../pages/AppUserManagementCompanyDelete')
)
export const AppUserManagementBusiness = lazy(
  () => import('../pages/AppUserManagementBusiness')
)
export const AppUserManagementBusinessNew = lazy(
  () => import('../pages/AppUserManagementBusinessNew')
)
export const AppUserManagementBusinessUpdate = lazy(
  () => import('../pages/AppUserManagementBusinessUpdate')
)
export const AppUserManagementBusinessDelete = lazy(
  () => import('../pages/AppUserManagementBusinessDelete')
)
export const AppUserManagementSecurity = lazy(
  () => import('../pages/AppUserManagementSecurity')
)
export const AppEquipmentManagement = lazy(
  () => import('../pages/AppEquipmentManagement')
)
export const AppEquipmentManagementStockControl = lazy(
  () => import('../pages/AppEquipmentManagementStockControl')
)
export const AppBatteriesManagement = lazy(
  () => import('../pages/AppBatteriesManagement')
)
export const AppBatteriesManagementSummary = lazy(
  () => import('../pages/AppBatteriesManagementSummary')
)
export const AppBatteriesManagementStockControl = lazy(
  () => import('../pages/AppBatteriesManagementStockControl')
)
export const AppBatteriesManagementDetailBattery = lazy(
  () => import('../pages/AppBatteriesManagementDetailBattery')
)
export const AppBatteriesManagementSiteDetail = lazy(
  () => import('../pages/AppBatteriesManagementSiteDetails')
)
export const AppBatteriesManagementAddBattery = lazy(
  () => import('../pages/AppBatteriesManagementAddBattery')
)
export const AppBatteriesManagementInstallBattery = lazy(
  () => import('../pages/AppBatteriesManagementInstall')
)
export const AppBatteriesManagementAssignBattery = lazy(
  () => import('../pages/AppBatteriesManagementAssign')
)
export const AppBatteriesManagementReturnBattery = lazy(
  () => import('../pages/AppBatteriesManagementReturnBattery')
)
export const AppBatteriesManagementBatteryHistory = lazy(
  () => import('../pages/AppBatteriesManagementBatteryHistory')
)
export const AppBatteriesManagementBatteryHistoryDetail = lazy(
  () => import('../pages/AppBatteriesManagementBatteryHistoryDetail')
)

export const AppBatteriesManagementImport = lazy(
  () => import('../pages/AppBatteriesManagementImport')
)

export const AppBatteriesManagementExport = lazy(
  () => import('../pages/AppBatteriesManagementExport')
)

export const AppPageTest = lazy(() => import('../pages/PageTest'))

export const AppDashboard = lazy(() => import('../pages/AppDashboard'))

export const AppDriveTestControl = lazy(
  () => import('../pages/AppDriveTestControl')
)

export const AppDriveTestControlDashboard = lazy(
  () => import('../pages/AppDriveTestControlDashboard')
)

export const AppDriveTestControlSettings = lazy(
  () => import('../pages/AppDriveTestControlSettings')
)
export const AppDriveTestControlNew = lazy(
  () => import('../pages/AppDriveTestControlNew')
)
export const AppDriveTestControlUpdate = lazy(
  () => import('../pages/AppDriveTestControlUpdate')
)
export const AppDriveTestControlCollectionCycleNew = lazy(
  () => import('../pages/AppDriveTestControlCollectionCycleNew')
)
export const AppDriveTestControlCollectionCycleUpdate = lazy(
  () => import('../pages/AppDriveTestControlCollectionCycleUpdate')
)
export const AppSiteView = lazy(() => import('../pages/AppSiteView'))
export const AppAuditManagementAnswerNew = lazy(
  () => import('../pages/AppAuditManagementAnswerNew')
)
export const AppBatteriesManagementDashboard = lazy(
  () => import('../pages/AppBatteriesManagementDashboard')
)
export const AppAUditManagementDashboard = lazy(
  () => import('../pages/AppAuditManagementDashboard')
)

export const AppBatteriesManagementDeleteBatteries = lazy(
  () => import('../pages/AppBatteriesManagementDeleteBatteries')
)

export const AppSiteVisits = lazy(() => import('../pages/AppSiteVisits'))
export const AppSiteVisitsDashboard = lazy(
  () => import('../pages/AppSiteVisitsDashboard')
)
export const AppSiteVisitsWorkInProgress = lazy(
  () => import('../pages/AppSiteVisitsWorkInProgress')
)
export const AppSiteVisitsDetails = lazy(
  () => import('../pages/AppSiteVisitsDetails')
)

export const AppModelManagementList = lazy(
  () => import('../pages/AppModelManagemetList')
)
export const AppGroupsModelManagement = lazy(
  () => import('../pages/AppModelGroupsManagement')
)
export const AppSiteVisitsLive = lazy(
  () => import('../pages/AppSiteVisitsLive')
)
export const AppSiteVisitsLiveView = lazy(
  () => import('../pages/AppSiteVisitsLiveView')
)
export const AppSiteVisitsGroupRealtimeNew = lazy(
  () => import('../pages/AppSiteVisitsGroupRealTimeNew')
)
export const AppSiteVisitsGroupRealtimeDelete = lazy(
  () => import('../pages/AppSiteVisitsGroupRealtimeDelete')
)
export const AppSiteVisitsGroupRealtimeUpdate = lazy(
  () => import('../pages/AppSiteVisitsGroupRealtimeUpdate')
)
export const AppBatteriesManagementExportLoader = lazy(
  () => import('../pages/AppBatteriesManagementExportLoader')
)
export const AppAuditManagementExternalData = lazy(
  () => import('../pages/AppAuditManagementExternalData')
)
export const AppPollAnswerDelete = lazy(
  () => import('../pages/AppPollAnswerDelete')
)
